<div >
    <div class="row w-100 my-3">
        <div class="col-12">
            <span class="pesonalSubtitle muted-color"> {{ 'PERSONAL.LABEL1' | translate }} </span>
        </div>
    </div>
    <form [formGroup]="formGroup">

        <div class="row">
            <div class="col-12">
                <span class="personalText muted-color"> {{ 'PERSONAL.LABEL2' | translate }} </span>

                <mat-card class="personalCard border-error">
                    <mat-card-content>
                        <mat-radio-group color="primary" class="radio-group-vertical" formControlName="owner">
                            <mat-radio-button value="true"> {{ 'PERSONAL.LABEL3' | translate }} </mat-radio-button>
                            <mat-divider inset class="my-2"></mat-divider>
                            <mat-radio-button value="false"> {{ 'PERSONAL.LABEL4' | translate }} </mat-radio-button>
                        </mat-radio-group>
                    </mat-card-content>
                </mat-card>
            </div>
        </div>
        <div *ngIf="formGroup.get('owner')?.value == 'true'; else elseBlock" (onCreate)="setPersonalData(false)"></div>
        <ng-template #elseBlock>
            <div (onCreate)="setPersonalData(true)"></div>
        </ng-template>
        <div class="row">
            <div class="col-12 my-3">
                <span class="personalTitle muted-color"> {{ 'PERSONAL.LABEL5' | translate }} </span>
            </div>
            <div class="col-12">
                <span class="personalText muted-color"> {{ 'PERSONAL.LABEL6' | translate }} </span>
            </div>

            <div class="col-12">
                <mat-card class="personalCard">
                    <mat-card-content>
                        <div class="row">
                            <div class="col-sm-12 col-md-4">
                                <mat-form-field appearance="outline" floatLabel="always" class="w-100">
                                    <mat-label> {{ 'PERSONAL.LABEL7' | translate }} </mat-label>
                                    <input matInput placeholder="" onpaste="return false" formControlName="name" (keypress)="commonService.validateCa($event)"/>
                                </mat-form-field>
                            </div>

                            <div class="col-sm-12 col-md-4">
                                <mat-form-field appearance="outline" floatLabel="always" class="w-100">
                                    <mat-label> {{ 'PERSONAL.LABEL8' | translate }} </mat-label>
                                    <input matInput placeholder="" onpaste="return false" formControlName="lastName" (keypress)="commonService.validateCa($event)"/>
                                </mat-form-field>
                            </div>

                            <div class="col-sm-12 col-md-4">
                                <mat-form-field appearance="outline" floatLabel="always" class="w-100">
                                    <mat-label> {{ 'PERSONAL.LABEL9' | translate }} </mat-label>
                                    <input matInput placeholder="" onpaste="return false" formControlName="secondLastName" (keypress)="commonService.validateCa($event)"/>
                                </mat-form-field>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-sm-12 col-md-4">
                                <mat-form-field appearance="outline" floatLabel="always" class="w-100">
                                    <mat-label> {{ 'PERSONAL.LABEL10' | translate }} </mat-label>
                                    <input matInput placeholder="" (keyup)="toLowerCase($event)" (keypress)="commonService.validateSpecialChar($event)" onpaste="return false" formControlName="email" />
                                </mat-form-field>
                            </div>

                            <div class="col-sm-12 col-md-4">
                                <mat-form-field appearance="outline" floatLabel="always" class="w-100">
                                    <mat-label> {{ 'PERSONAL.LABEL11' | translate }} </mat-label>
                                    <input matInput  placeholder="" onpaste="return false" formControlName="phone" maxlength="10" (keypress)="commonService.validateNo($event)"/>
                                </mat-form-field>
                                <div *ngIf="formGroup.controls['phone'].hasError('pattern')" ><span class="primary-color"> {{ 'PERSONAL.LABEL12' | translate }} </span></div>
                            </div>
                        </div>

                    </mat-card-content>
                </mat-card>
                <div class="d-none d-sm-none d-md-flex justify-content-end my-5">
                    <button class="w-25 p-1" type="button" (click)="stepBack()" mat-raised-button
                        color="accent"> {{ 'PERSONAL.LABEL13' | translate }} </button>
                    <button class="w-25 p-1 mx-2" type="submit" (click)="stepOn()" mat-raised-button
                        color="primary"> {{ 'PERSONAL.LABEL14' | translate }} </button>
                </div>
                <div class="d-block d-sm-block d-md-none">
                    <mat-card class="serviceCard my-3">
                        <mat-card-content>
                            <button class="w-100 p-1 mx-2" type="submit" (click)="stepOn()" mat-raised-button
                                color="primary"> {{ 'PERSONAL.LABEL14' | translate }} </button>
                        </mat-card-content>
                    </mat-card>
                </div>
            </div>
        </div>
    </form>
</div>